exports.getCookie = function (name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}

exports.setCookie = function (name, value, days) {
  console.log(name, value, days)
  var d = new Date()
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
  document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
}

exports.setCookieExpired = function (name, value, timestamp) {
  var d = new Date()
  d.setTime(timestamp)
  document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
}

exports.deleteCookie = function (name) { exports.setCookie(name, '', -1) }

function isExpired (expires) {
  const now = Math.floor(new Date().getTime() / 1000)
  return now >= expires
}

exports.getQiniuToken = function (vm) {
  let qiniuToken = vm.$store.state.qiniuToken
  let expires = vm.$store.state.qiniuTokenExpires
  if (qiniuToken && !isExpired(expires)) {
    return Promise.resolve(qiniuToken)
  } else {
    return vm.requests.getQiniuToken()
      .then(res => {
        vm.$store.state.qiniuToken = res.data.data.token
        vm.$store.state.qiniuTokenExpires = res.data.data.expires
        sessionStorage.setItem('qiniuToken', res.data.data.token)
        sessionStorage.setItem('qiniuTokenExpires', res.data.data.expires)
        return Promise.resolve(res.data.data.token)
      })
  }
}

exports.imageUpload = function (base64ImageData, fileSize, token) {
  let pic = base64ImageData.split(',')[1]
  let url = `https://upload-z1.qiniup.com/putb64/${fileSize}`
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest()
    xhr.open('POST', url, true)
    xhr.setRequestHeader('Content-Type', 'application/octet-stream')
    xhr.setRequestHeader('Authorization', `UpToken ${token}`)
    xhr.send(pic)
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return
      if (xhr.readyState === 4 && xhr.status === 200) {
        resolve(JSON.parse(xhr.response))
      } else {
        reject(xhr)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/lib/utils.js